import { useLocation } from 'react-router-dom';
import LoginForm from '../../../components/LoginForm/LoginForm';
import useOAuthLogin from '../hooks/useOAuthLogin';

const OAuthLoginPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const oauthRequestId = searchParams.get('oauth_request_id') || '';

  const { handleLogin, loginStatus } = useOAuthLogin(oauthRequestId);

  return <LoginForm onSubmit={handleLogin} status={loginStatus} />;
};

export default OAuthLoginPage;
